import { Chip } from "@mui/material";

interface MeteringPointActiveChipProps {
  isActive: boolean;
}

const MeteringPointActiveChip = ({ isActive }: MeteringPointActiveChipProps) =>
  isActive ? (
    <Chip label="Active" color="success" size="small" />
  ) : (
    <Chip label="Inactive" color="default" size="small" />
  );

export default MeteringPointActiveChip;
